// extracted by mini-css-extract-plugin
export default {"component":"Mobile_ConferenceEditNotesPage_component__BmZ+M","textAreaNotes":"Mobile_ConferenceEditNotesPage_textAreaNotes__CUdTy"};